import React from 'react'

import ActionsBox from '@/app/module/campaigns/component/actions/actions-box'
import { SMS_ACTION_DEFAULT_SENDERID } from '@/app/module/campaigns/definitions'
import { LocalAction, LocalWhatsAppListItem } from '@/app/module/campaigns/types'
import { ActionOption } from '@/app/module/campaigns/utils/actions/options'

import { ActionProps, ApiProps } from './part-config-props'
import ChoiceContainer from './question/choice/choice-container'
import WhatsappListChoice from './question/choice/whatsapp-list-choice'

type Props = ApiProps &
  ActionProps & {
    actionOptions: ActionOption[]
    hasTranscribe: boolean
    isCloseDisabled?: boolean
    listIndex: number
    transcribeEnabled: boolean
    value: LocalWhatsAppListItem

    onChange: (listIndex: number, value: LocalWhatsAppListItem) => void
    onClose: (listIndex: number) => void
  }

const updateContactConfig = {
  invalid: false,
  openResponse: false,
  question: true,
}

const WhatsappListItem: React.FC<Props> = ({ listIndex, onChange, onClose, ...props }) => {
  const handleChange = React.useCallback(
    (value: Partial<LocalWhatsAppListItem>) => onChange(listIndex, { ...props.value, ...value }),
    [listIndex, props.value, onChange],
  )
  const handleClose = React.useCallback(() => onClose(listIndex), [listIndex, onClose])

  const handleActionChange = React.useCallback(
    (actionsList: LocalAction[]) =>
      handleChange({
        actions: actionsList,
      }),
    [handleChange],
  )
  const handleLabelChange = React.useCallback(
    (label: string) => {
      handleChange({
        label,
      })
    },
    [handleChange],
  )
  const handleListItemChange = React.useCallback(
    (choiceList: Partial<LocalWhatsAppListItem>) =>
      handleChange({
        ...choiceList,
      }),
    [handleChange],
  )

  return (
    <ActionsBox
      {...props}
      actionOptions={props.actionOptions}
      actions={props.value.actions || []}
      defaultSenderId={SMS_ACTION_DEFAULT_SENDERID.actionsOnly}
      label={props.value.label || ''}
      updateContactConfig={updateContactConfig}
      onChange={handleActionChange}
      onClose={handleClose}
      onLabelChange={handleLabelChange}
    >
      <ChoiceContainer label="Option Content">
        <WhatsappListChoice tagList={props.value} onChange={handleListItemChange} />
      </ChoiceContainer>
    </ActionsBox>
  )
}

export default React.memo(WhatsappListItem)
